import { createStore } from 'vuex'

import killmail from './killmail.module';

export default createStore({
  modules: {
    killmail,
  },
})